var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aula-calendar-aside-container"},[(!_vm.isMobile)?_c('widget-placeholder',{attrs:{"list-of-widgets":_vm.getListWidgets,"placement":"narrow"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }